import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

export default function AdminSettings() {
  const [form, setForm] = useState({
    opening_start: "07:00",
    opening_end: "20:00",
    min_minutes: 15,
    max_minutes: 480,
    require_approval: false,
    allow_recurring: true,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api
      .get("/settings")
      .then((r) => setForm(r.data))
      .catch((err) => toast.error(formatApiError(err)));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.put("/settings", form);
      toast.success("Indstillinger gemt");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight">Indstillinger</h1>
        <p className="text-slate-500 mt-1">Bookingregler og åbningstider</p>
      </div>

      <Card className="p-8 rounded-2xl border-slate-200 max-w-2xl">
        <form onSubmit={save} className="space-y-6" data-testid="settings-form">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Åbningstid - start</Label>
              <Input type="time" value={form.opening_start} onChange={(e) => setForm({ ...form, opening_start: e.target.value })} className="h-11 rounded-xl" />
            </div>
            <div className="space-y-2">
              <Label>Åbningstid - slut</Label>
              <Input type="time" value={form.opening_end} onChange={(e) => setForm({ ...form, opening_end: e.target.value })} className="h-11 rounded-xl" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Minimum bookinglængde (min)</Label>
              <Input type="number" min={5} value={form.min_minutes} onChange={(e) => setForm({ ...form, min_minutes: parseInt(e.target.value) || 5 })} className="h-11 rounded-xl" data-testid="min-minutes-input" />
            </div>
            <div className="space-y-2">
              <Label>Maksimum bookinglængde (min)</Label>
              <Input type="number" min={15} value={form.max_minutes} onChange={(e) => setForm({ ...form, max_minutes: parseInt(e.target.value) || 60 })} className="h-11 rounded-xl" data-testid="max-minutes-input" />
            </div>
          </div>
          <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
            <div>
              <Label className="cursor-pointer">Kræv godkendelse af bookinger</Label>
              <p className="text-xs text-slate-500 mt-0.5">Bookinger skal godkendes af admin før de aktiveres</p>
            </div>
            <Switch checked={form.require_approval} onCheckedChange={(v) => setForm({ ...form, require_approval: v })} data-testid="require-approval-switch" />
          </div>
          <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
            <div>
              <Label className="cursor-pointer">Tillad gentagne bookinger</Label>
              <p className="text-xs text-slate-500 mt-0.5">Brugere kan oprette tilbagevendende bookinger</p>
            </div>
            <Switch checked={form.allow_recurring} onCheckedChange={(v) => setForm({ ...form, allow_recurring: v })} data-testid="allow-recurring-switch" />
          </div>
          <Button type="submit" disabled={loading} className="rounded-xl bg-slate-900 hover:bg-slate-800 h-11 px-6" data-testid="save-settings-button">
            {loading ? "Gemmer…" : "Gem indstillinger"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
